import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const Bookmark: FC<Props> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.277 2.56975C4.85633 2.15475 5.6239 2 6.42391 2H10.065C10.8915 2 11.6649 2.16606 12.241 2.60717C12.8387 3.06481 13.1544 3.76425 13.1544 4.66838L13.1574 12.9916C13.1574 13.1663 13.1117 13.3361 13.0271 13.4857C12.7543 13.9698 12.141 14.1394 11.6581 13.8676L11.6575 13.8673L8.26065 11.9485L4.82999 13.8716C4.67996 13.9555 4.51034 14 4.33786 14C3.78241 14 3.33243 13.5496 3.33325 12.9944V4.56316C3.33325 3.67602 3.6725 3.00279 4.277 2.56975ZM4.81456 3.32016C4.48021 3.55967 4.25633 3.93724 4.25633 4.56316V12.9957C4.25624 13.0402 4.29234 13.0769 4.33786 13.0769C4.35211 13.0769 4.36616 13.0734 4.37893 13.0662L8.03579 11.0163C8.17647 10.9374 8.3481 10.9377 8.48847 11.017L12.1109 13.0632C12.1512 13.0858 12.2012 13.0712 12.223 13.0324L12.2235 13.0314C12.231 13.0183 12.2343 13.005 12.2343 12.9919L12.2313 4.66871C12.2313 3.9958 12.0084 3.59163 11.6798 3.34007C11.3297 3.07196 10.7891 2.92308 10.065 2.92308H6.42391C5.72106 2.92308 5.17407 3.06262 4.81456 3.32016Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default Bookmark;
